import removeSpaces from "./removeSpaces";


const formatSireXNumber = (value: string) => {
	if (!value) return '';
	
	const digits = removeSpaces(value);
	
	let formattedSireX = '';
	for (let i = 0; i < digits.length; i++) {
		if (i === 3 || i === 6 || i === 9) {
			formattedSireX += ' ';
		}
		formattedSireX += digits[i];
	}
	
	return formattedSireX;
};

export default formatSireXNumber;
